import axios from "./api"; // 倒入 api
import config from "./config.js"; // 倒入默认配置
export const BASEURL = config.baseURL;

/* 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */

export const IMAGEPATH = BASEURL + "crm";

// 系统管理-获取短信发送记录
export const GET_MESSAGE_RECORD = (params) => {
  return axios({
    url: "sms/page",
    method: "POST",
    data: params,
  });
};

// 系统管理-获取文件下载列表
export const GET_DOWNLOAD_LIST = (params) => {
  return axios({
    url: "/download/page",
    method: "POST",
    data: params,
  });
};

// 员工休息模式-开关
export const UPDATE_EMPLOYEE_STATUS = (params) => {
  return axios({
    url: "/switch/state3",
    method: "GET",
    params,
  });
};

// 修改配量
export const UPDATE_EMPLOYEE_ACTION = (params) => {
  return axios({
    url: "/employee/update/action",
    method: "POST",
    data: params,
  });
};
